import React, { useRef } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import EventBus from "../common/EventBus";

const SignOut = ({ open, close }) => {

  // prevents multiple logout triggers
  const isLoggingOut = useRef(false);

  const handleLogout = () => {

    // BLOCK MULTIPLE FIRING
    if (isLoggingOut.current) return;

    isLoggingOut.current = true;

    console.log("SIGNOUT CLICKED");

    // SAME FLOW AS AUTO LOGOUT
    EventBus.dispatch("logout");

    close();

    // reset lock after short delay
    setTimeout(() => {
      isLoggingOut.current = false;
    }, 1000);
  };

  const handleClose = () => {
    close();
    isLoggingOut.current = false; // reset if user cancels
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
    >
      <DialogTitle>Signout Option</DialogTitle>

      <DialogContent>
        <DialogContentText>
          Are you sure to logout?
        </DialogContentText>
      </DialogContent>

      <DialogActions>

        <Button
          onClick={handleLogout}
          color="error"
          type="button"
        >
          Yes
        </Button>

        <Button
          onClick={handleClose}
          type="button"
        >
          No
        </Button>

      </DialogActions>
    </Dialog>
  );
};

export default SignOut;